<template>
  <activity :fonts="fonts" :message="liveMessage">
    <component
      :is="currentComponent"
      @hook:updated="focusFirstFocusableElement"
    ></component>
  </activity>
</template>

<script>
import { Activity } from '@discoveryeducation/components';
import { mapGetters } from 'vuex';
import { GamePage, IntroPage, LoadingPage } from '../pages';

export default {
  name: 'MainView',
  components: {
    Activity,
    IntroPage,
    LoadingPage,
    GamePage,
  },
  data() {
    return {
      slideVideos: [],
      fonts: [
        'Nunito-Black',
        'Nunito-Light',
        'Nunito-Bold',
        'Nunito-Semibold',
        'Nunito-ExtraBold',
        'Architects-Daughter',
      ],
    };
  },
  mounted() {
    this.setActivityResources({
      data: `config/data-initial.js`,
      media: `config/media.js`,
      moduleName: 'virtuallab',
    });

    this.onSwapComponent('LoadingPage');
  },
  methods: {
    async preloadVideos() {
      const checkDownload = this.slideVideos.some(
        (v) => v.downloadStarted === true,
      );

      if (!checkDownload && !this.slideVideos.length) {
        this.slideVideos = this.data.slides
          .filter((s) => s.component !== 'Slide0')
          .map((s) => {
            return s.video;
          });

        for (const [index, video] of this.slideVideos.entries()) {
          this.data.slides[index].video.downloadStarted = true;
          const currentVideo = await this.helpers.utils.preloadVideo(video);
          this.setVideos(currentVideo);
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      currentComponent: 'ActivityManagerModule/getCurrentComponent',
    }),
  },
  watch: {
    currentComponent(newCurrentComponent) {
      if (newCurrentComponent !== 'LoadingPage') {
        this.preloadVideos();
      }
    },
  },
};
</script>
